import { Header } from "../components/Header";

const H = ({ children }) => <h2 className="font-serif text-2xl mt-10 mb-3">{children}</h2>;
const P = ({ children }) => <p className="text-ink-soft leading-relaxed mb-3">{children}</p>;

export default function LegalPage({ type }) {
  const privacy = type === "privacy";
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main data-testid={`legal-${type}`} className="max-w-3xl mx-auto px-5 md:px-8 pt-32 pb-24">
        <div className="text-[11px] uppercase tracking-[0.3em] text-sand mb-3">Informazioni legali</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-light">{privacy ? "Privacy Policy" : "Cookie Policy"}</h1>
        <P>Titolare del trattamento: Fantini Auto Srl — Brescia. Contatti: <a className="underline" href="mailto:info@fantiniauto.com">info@fantiniauto.com</a>.</P>
        {privacy ? (
          <>
            <H>Dati trattati</H>
            <P>Raccogliamo i dati che inserisci nel percorso di acquisto guidato: nome, telefono, email, dati della vettura in permuta, preferenze di acquisto e finanziamento, richieste di preventivo, appuntamento o videochiamata, oltre ai dati necessari all'eventuale deposito tramite il circuito di pagamento Stripe.</P>
            <H>Finalità e base giuridica</H>
            <P>I dati sono trattati per rispondere alle tue richieste, predisporre preventivi, gestire appuntamenti e il blocco della vettura (esecuzione di misure precontrattuali, art. 6.1.b GDPR) e per adempiere a obblighi di legge. Non effettuiamo profilazione né cessione a terzi per finalità di marketing.</P>
            <H>Conservazione</H>
            <P>I dati sono conservati per il tempo necessario a gestire la richiesta e, in caso di contratto, per i termini previsti dalla normativa fiscale e civilistica.</P>
            <H>Destinatari</H>
            <P>Fornitori tecnici che operano come responsabili del trattamento: hosting, servizio email, Stripe (pagamenti), WhatsApp/Meta per i contatti che avvii volontariamente.</P>
            <H>I tuoi diritti</H>
            <P>Puoi chiedere accesso, rettifica, cancellazione, limitazione, portabilità e opporti al trattamento scrivendo a info@fantiniauto.com. Hai diritto di proporre reclamo al Garante per la protezione dei dati personali.</P>
          </>
        ) : (
          <>
            <H>Cosa sono i cookie</H>
            <P>I cookie sono piccoli file salvati sul tuo dispositivo che permettono al sito di funzionare e di ricordare le tue scelte.</P>
            <H>Cookie tecnici (sempre attivi)</H>
            <P>Necessari per la navigazione, per mantenere la sessione dell'area riservata e per ricordare il consenso espresso in questo banner. Non richiedono consenso.</P>
            <H>Cookie di terze parti (con consenso)</H>
            <P>Stripe, per la sicurezza dei pagamenti del deposito, e WhatsApp/Meta quando scegli di contattarci tramite il pulsante dedicato. Vengono attivati solo dopo il tuo "Accetta".</P>
            <H>Gestione del consenso</H>
            <P>Puoi modificare la scelta in qualsiasi momento cancellando i dati del sito dal browser; al successivo accesso il banner verrà riproposto. Puoi inoltre bloccare i cookie dalle impostazioni del browser.</P>
          </>
        )}
      </main>
    </div>
  );
}
